import { Dropdown } from "tailwindcss-stimulus-components"

// The library dropdown, for menus inside a drawer. While the menu is open,
// Escape closes just the menu; once it's closed, Escape reaches the drawer
// as usual.
export default class extends Dropdown {
  escape(event) {
    if (!this.openValue) return
    event.stopPropagation()
    this.openValue = false
  }
}
